// ============================================================
// MÓDULO CONTABILIDAD
// ============================================================

import {
    mostrarToast,
    obtenerUrlBackend
} from './utilerias.js';

import {
    GestorGrafica
} from './graficaModulo.js';


const URL_BASE_API =
    obtenerUrlBackend('8083');

const API_BASE_URL =
    `${URL_BASE_API}/api/contabilidad`;

const TOKEN_KEY =
    'token_teresita';


// ============================================================
// ESTADO GENERAL
// ============================================================

let cuentasContabilidad = [];
let cuentasFiltradas = [];

let modoSeleccion = false;
let cuentasSeleccionadas = new Set();

let columnasVisibles = {
    cuenta: true,
    descripcion: true
};

let filtrosContabilidad = {
    cuenta: '',
    descripcion: ''
};

let timerGuardarFiltros = null;
let filtrosExpandidos = false;


// ============================================================
// ESTADO DE GRÁFICA
// ============================================================

let graficaContabilidad = null;

let cuentasGraficaContabilidad = [];

let entidadesContabilidad = [];

let aniosContabilidad = [];

let vistaGraficaContabilidad =
    'entidad';

let sumarRegistrosContabilidad =
    false;

let ultimaPreferenciaGrafica =
    null;


// ============================================================
// TEMPLATE
// ============================================================

const templateContabilidad = `

<div
    id="contabilidadRoot"
    class="contabilidad-container"
>

    <!-- =====================================================
         PANEL MOSTRAR COLUMNAS
    ====================================================== -->

    <div
        id="contabilidadPanelMostrar"
        class="contabilidad-panel-mostrar"
        style="display:none;"
    >

        <div class="contabilidad-panel-mostrar__titulo">
            Mostrar columnas
        </div>

        <label>

            <input
                type="checkbox"
                id="mostrarColumnaCuenta"
                checked
            >

            Cuenta

        </label>


        <label>

            <input
                type="checkbox"
                id="mostrarColumnaDescripcion"
                checked
            >

            Descripción

        </label>


        <button
            type="button"
            id="btnMostrarTodasColumnas"
            class="contabilidad-mostrar-todas"
        >
            Mostrar todas las columnas
        </button>

    </div>


    <!-- =====================================================
         VISTA TABLA
    ====================================================== -->

    <div id="contabilidadVistaTabla">

        <div class="contabilidad-tabla-wrapper">

            <div
                id="contabilidadSeleccionToolbar"
                class="contabilidad-seleccion-toolbar"
                style="display:none;"
            >

                <label
                    class="contabilidad-seleccionar-todos"
                >

                    <input
                        type="checkbox"
                        id="contabilidadSeleccionarTodos"
                    >

                    Todos

                </label>


                <button
                    type="button"
                    id="btnGraficarContabilidad"
                    class="btn btn-primary"
                    disabled
                >
                    Graficar
                </button>

            </div>


            <table
                id="tablaContabilidad"
                class="contabilidad-tabla"
            >

                <thead>

                    <tr>

                        <th
                            id="contabilidadSeleccionHeader"
                            class="contabilidad-col-seleccion"
                            style="display:none;"
                        ></th>


                        <th class="contabilidad-col-cuenta">
                            Cuenta
                        </th>


                        <th class="contabilidad-col-descripcion">
                            Descripción
                        </th>


                        <th class="contabilidad-col-filtro-toggle">

                            <button
                                type="button"
                                id="btnToggleFiltrosContabilidad"
                                class="contabilidad-btn-toggle-filtros"
                                title="Mostrar filtros"
                            >

                                <i
                                    id="iconToggleFiltrosContabilidad"
                                    class="fas fa-chevron-down"
                                ></i>

                            </button>

                        </th>

                    </tr>


                    <tr
                        id="filaFiltrosContabilidad"
                        class="contabilidad-filtros"
                        style="display:none;"
                    >

                        <th
                            id="contabilidadSeleccionFiltro"
                            class="contabilidad-col-seleccion"
                            style="display:none;"
                        ></th>


                        <th class="contabilidad-col-cuenta">

                            <input
                                type="text"
                                id="filtroCuenta"
                                class="contabilidad-filtro"
                                autocomplete="off"
                            >

                        </th>


                        <th class="contabilidad-col-descripcion">

                            <input
                                type="text"
                                id="filtroDescripcion"
                                class="contabilidad-filtro"
                                autocomplete="off"
                            >

                        </th>


                        <th class="contabilidad-col-filtro-toggle">

                            <button
                                type="button"
                                id="btnLimpiarFiltrosContabilidad"
                                class="contabilidad-btn-limpiar-filtros"
                                title="Limpiar filtros"
                            >

                                <i class="fas fa-trash"></i>

                            </button>

                        </th>

                    </tr>

                </thead>


                <tbody
                    id="tablaContabilidadBody"
                ></tbody>

            </table>


            <div
                id="contabilidadSinResultados"
                class="contabilidad-sin-resultados"
                style="display:none;"
            >
                No se encontraron cuentas.
            </div>

        </div>

    </div>


    <!-- =====================================================
         VISTA GRÁFICA
    ====================================================== -->

    <div
        id="contabilidadVistaGrafica"
        style="display:none;"
    >

        <div class="card">

            <div
                class="
                    d-flex
                    justify-content-between
                    align-items-center
                    p-3
                    pb-0
                "
            >

                <button
                    type="button"
                    class="btn btn-sm btn-outline-secondary"
                    id="btnVolverContabilidad"
                >
                    <i class="fa-solid fa-arrow-left me-1"></i>
                    Volver
                </button>


                <div
                    id="contabilidadCuentasGrafica"
                    class="small text-secondary px-3 text-truncate"
                    style="flex:1;"
                ></div>


                <button
                    type="button"
                    class="btn btn-sm btn-outline-dark"
                    id="btnParametrosContabilidad"
                    data-bs-toggle="modal"
                    data-bs-target="#modalParametrosContabilidad"
                >
                    <i class="fa-solid fa-sliders me-1"></i>
                    Parámetros
                </button>

            </div>


            <div class="card-body">

                <div style="height:500px;">
                    <canvas id="cont-grafica"></canvas>
                </div>

            </div>

        </div>


        <!-- =================================================
             MODAL PARÁMETROS
        ================================================== -->

        <div
            class="modal fade"
            id="modalParametrosContabilidad"
            tabindex="-1"
        >

            <div class="modal-dialog">

                <div class="modal-content">

                    <div class="modal-header">

                        <h5 class="modal-title">
                            <i class="fa-solid fa-sliders me-1"></i>
                            Parámetros
                        </h5>

                        <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                        ></button>

                    </div>


                    <div class="modal-body">

                        <!-- PERIODO -->

                        <div class="mb-3">

                            <div class="fw-bold mb-2">
                                Periodo
                            </div>

                            <div class="row">

                                <div class="col-6">

                                    <label
                                        for="cont-fecha-inicio"
                                        class="form-label"
                                    >
                                        Desde:
                                    </label>

                                    <input
                                        type="month"
                                        id="cont-fecha-inicio"
                                        class="form-control"
                                    >

                                </div>


                                <div class="col-6">

                                    <label
                                        for="cont-fecha-fin"
                                        class="form-label"
                                    >
                                        Hasta:
                                    </label>

                                    <input
                                        type="month"
                                        id="cont-fecha-fin"
                                        class="form-control"
                                    >

                                </div>

                            </div>

                        </div>


                        <hr>


                        <!-- SUMAR REGISTROS -->

                        <div class="mb-3">

                            <div
                                class="
                                    d-flex
                                    align-items-center
                                    justify-content-between
                                    flex-wrap
                                    gap-2
                                "
                            >

                                <div class="fw-bold">
                                    Sumar registros seleccionados
                                </div>


                                <div>

                                    <div class="form-check form-check-inline">

                                        <input
                                            class="form-check-input"
                                            type="radio"
                                            name="cont-sumar-registros"
                                            id="cont-sumar-si"
                                            value="si"
                                        >

                                        <label
                                            class="form-check-label"
                                            for="cont-sumar-si"
                                        >
                                            Sí
                                        </label>

                                    </div>


                                    <div class="form-check form-check-inline">

                                        <input
                                            class="form-check-input"
                                            type="radio"
                                            name="cont-sumar-registros"
                                            id="cont-sumar-no"
                                            value="no"
                                            checked
                                        >

                                        <label
                                            class="form-check-label"
                                            for="cont-sumar-no"
                                        >
                                            No
                                        </label>

                                    </div>

                                </div>

                            </div>


                            <div
                                id="cont-sumar-ayuda"
                                class="form-text"
                            >
                                Al seleccionar Sí se suman todas las cuentas
                                seleccionadas y todas las entidades.
                            </div>

                        </div>


                        <hr>


                        <!-- ENTIDADES / VISTA -->

                        <div
                            id="cont-bloque-entidades"
                            class="mb-3"
                        >

                            <div class="mb-3">

                                <div class="fw-bold mb-2">
                                    Entidad
                                </div>

                                <div
                                    id="cont-lista-entidades"
                                ></div>

                            </div>


                            <div>

                                <div class="fw-bold mb-2">
                                    Mostrar datos por
                                </div>


                                <div class="form-check form-check-inline">

                                    <input
                                        class="form-check-input"
                                        type="radio"
                                        name="cont-vista-grafica"
                                        id="cont-vista-entidad"
                                        value="entidad"
                                        checked
                                    >

                                    <label
                                        class="form-check-label"
                                        for="cont-vista-entidad"
                                    >
                                        Entidad
                                    </label>

                                </div>


                                <div class="form-check form-check-inline">

                                    <input
                                        class="form-check-input"
                                        type="radio"
                                        name="cont-vista-grafica"
                                        id="cont-vista-total"
                                        value="total"
                                    >

                                    <label
                                        class="form-check-label"
                                        for="cont-vista-total"
                                    >
                                        Total
                                    </label>

                                </div>

                            </div>

                        </div>


                        <hr>


                        <!-- CONCEPTO -->

                        <div class="row mb-2">

                            <div class="col-6 fw-bold">
                                Concepto
                            </div>

                            <div class="col-3 text-center">
                                Real
                            </div>

                            <div class="col-3 text-center">
                                Promedio
                            </div>

                        </div>


                        <div class="row align-items-center">

                            <div class="col-6">
                                IMPORTE
                            </div>


                            <div class="col-3 text-center">

                                <input
                                    class="
                                        form-check-input
                                        cont-metrica-selector
                                    "
                                    type="checkbox"
                                    data-tipo="Real"
                                    value="Real"
                                    id="cont-real"
                                >

                            </div>


                            <div class="col-3 text-center">

                                <input
                                    class="
                                        form-check-input
                                        cont-metrica-selector
                                    "
                                    type="checkbox"
                                    data-tipo="Promedio"
                                    value="Promedio"
                                    id="cont-promedio"
                                >

                            </div>

                        </div>

                    </div>


                    <div class="modal-footer">

                        <button
                            type="button"
                            class="btn btn-outline-secondary"
                            id="btnLimpiarParametrosContabilidad"
                        >
                            Limpiar
                        </button>


                        <button
                            type="button"
                            class="btn btn-secondary"
                            id="btnGenerarGraficaContabilidad"
                        >
                            Graficar
                        </button>

                    </div>

                </div>

            </div>

        </div>

    </div>

</div>

`;


// ============================================================
// TOKEN
// ============================================================

function getToken() {
    return sessionStorage.getItem(
        TOKEN_KEY
    );
}


// ============================================================
// EXPORT DE VISTA
// ============================================================

export function paginaContabilidad() {

    modoSeleccion = false;

    cuentasSeleccionadas.clear();

    filtrosExpandidos = false;

    setTimeout(
        () => inicializarContabilidad(),
        0
    );

    return templateContabilidad;
}


// ============================================================
// INICIALIZAR
// ============================================================

async function inicializarContabilidad() {

    crearGestorGrafica();

    bindEventsContabilidad();

    await Promise.all([
        cargarPreferenciasColumnas(),
        cargarPreferenciasFiltros(),
        cargarEntidadesContabilidad(),
        cargarAniosContabilidad()
    ]);

    actualizarControlesColumnas();

    await cargarCuentas();

    await restaurarUltimaGraficaContabilidad();
}


// ============================================================
// GESTOR DE GRÁFICA
// ============================================================

function crearGestorGrafica() {

    graficaContabilidad =
        new GestorGrafica({

            idInicio:
                'cont-fecha-inicio',

            idFin:
                'cont-fecha-fin',

            idContenedorMetricas:
                'cont-lista-conceptos',

            idCanvas:
                'cont-grafica',

            storageKey:
                'preferenciasGraficaContabilidad',

            selectorCheckboxes:
                '.cont-metrica-selector',

            posicionLeyenda:
                'bottom',

            onLegendChange:
                async () => {

                    await guardarPreferenciaGraficaContabilidad();

                }

        });

}


// ============================================================
// CUENTAS
// ============================================================

async function cargarCuentas() {

    try {

        const response =
            await fetch(
                `${API_BASE_URL}/cuentas`,
                {
                    method: 'GET',

                    headers: {
                        'Authorization':
                            getToken(),

                        'Content-Type':
                            'application/json'
                    }
                }
            );


        if (!response.ok) {

            throw new Error(
                'Error al cargar cuentas'
            );

        }


        const resultado =
            await response.json();


        if (
            !resultado.success ||
            !Array.isArray(resultado.cuentas)
        ) {

            throw new Error(
                'Respuesta inválida del servidor'
            );

        }


        cuentasContabilidad =
            resultado.cuentas;


        restaurarFiltrosEnInputs();

        aplicarFiltros(false);


    } catch (error) {

        console.error(
            'Error al cargar Contabilidad:',
            error
        );


        mostrarToast(
            'No fue posible cargar las cuentas',
            'error'
        );

    }

}


// ============================================================
// FILTRAR
// ============================================================

function aplicarFiltros(
    guardar = true
) {

    const filtroCuenta =
        document
            .getElementById(
                'filtroCuenta'
            )
            ?.value
            .trim()
            .toLowerCase() || '';


    const filtroDescripcion =
        document
            .getElementById(
                'filtroDescripcion'
            )
            ?.value
            .trim()
            .toLowerCase() || '';


    filtrosContabilidad = {
        cuenta:
            filtroCuenta,

        descripcion:
            filtroDescripcion
    };


    cuentasFiltradas =
        cuentasContabilidad.filter(
            cuenta => {

                const codigo =
                    String(
                        cuenta.codigo || ''
                    )
                    .toLowerCase();


                const descripcion =
                    String(
                        cuenta.descripcion || ''
                    )
                    .toLowerCase();


                const coincideCuenta =
                    !filtroCuenta ||
                    codigo.startsWith(
                        filtroCuenta
                    );


                const coincideDescripcion =
                    !filtroDescripcion ||
                    descripcion.includes(
                        filtroDescripcion
                    );


                return (
                    coincideCuenta &&
                    coincideDescripcion
                );

            }
        );


    renderizarCuentas();


    if (guardar) {

        programarGuardadoFiltros();

    }

}


// ============================================================
// RENDERIZAR CUENTAS
// ============================================================

function renderizarCuentas() {

    const tbody =
        document.getElementById(
            'tablaContabilidadBody'
        );


    const mensajeSinResultados =
        document.getElementById(
            'contabilidadSinResultados'
        );


    if (!tbody) return;


    tbody.innerHTML = '';


    if (
        cuentasFiltradas.length === 0
    ) {

        if (mensajeSinResultados) {

            mensajeSinResultados.style.display =
                'block';

        }


        actualizarEstadoSeleccion();

        aplicarVisibilidadColumnas();

        return;

    }


    if (mensajeSinResultados) {

        mensajeSinResultados.style.display =
            'none';

    }


    tbody.innerHTML =
        cuentasFiltradas
            .map(cuenta => {

                const codigo =
                    String(
                        cuenta.codigo
                    );


                const seleccionada =
                    cuentasSeleccionadas.has(
                        codigo
                    );


                return `

                    <tr>

                        ${
                            modoSeleccion
                                ? `

                                    <td
                                        class="
                                            contabilidad-col-seleccion
                                        "
                                    >

                                        <input
                                            type="checkbox"
                                            class="
                                                contabilidad-check-cuenta
                                            "
                                            data-codigo="${escapeHtml(codigo)}"
                                            ${
                                                seleccionada
                                                    ? 'checked'
                                                    : ''
                                            }
                                        >

                                    </td>

                                `
                                : ''
                        }


                        <td
                            class="
                                contabilidad-col-cuenta
                            "
                        >

                            <button
                                type="button"
                                class="
                                    contabilidad-cuenta-link
                                "
                                data-codigo="${escapeHtml(codigo)}"
                                data-descripcion="${escapeHtml(
                                    cuenta.descripcion || ''
                                )}"
                            >

                                ${escapeHtml(codigo)}

                            </button>

                        </td>


                        <td
                            class="
                                contabilidad-col-descripcion
                            "
                        >

                            ${escapeHtml(
                                cuenta.descripcion || ''
                            )}

                        </td>


                        <td></td>

                    </tr>

                `;

            })
            .join('');


    actualizarEstadoSeleccion();

    aplicarVisibilidadColumnas();

}


// ============================================================
// ABRIR GRÁFICA DESDE UNA CUENTA
// ============================================================

async function abrirCuentaContabilidad(
    codigo
) {

    await abrirGraficaContabilidad([
        String(codigo)
    ]);

}


// ============================================================
// ABRIR VISTA DE GRÁFICA
// ============================================================

async function abrirGraficaContabilidad(
    codigos,
    {
        abrirParametros = true,
        restaurando = false
    } = {}
) {

    cuentasGraficaContabilidad =
        [...new Set(
            (codigos || []).map(String)
        )];


    if (
        cuentasGraficaContabilidad.length === 0
    ) {

        mostrarToast(
            'Selecciona al menos una cuenta.',
            'warning'
        );

        return;

    }


    const vistaTabla =
        document.getElementById(
            'contabilidadVistaTabla'
        );


    const vistaGrafica =
        document.getElementById(
            'contabilidadVistaGrafica'
        );


    if (vistaTabla) {
        vistaTabla.style.display =
            'none';
    }


    if (vistaGrafica) {
        vistaGrafica.style.display =
            '';
    }


    actualizarTextoCuentasGrafica();

    actualizarDisponibilidadSuma();


    if (
        abrirParametros &&
        !restaurando
    ) {

        abrirModalParametros();

    }

}


// ============================================================
// VOLVER A TABLA
// ============================================================

function volverTablaContabilidad() {

    const vistaTabla =
        document.getElementById(
            'contabilidadVistaTabla'
        );


    const vistaGrafica =
        document.getElementById(
            'contabilidadVistaGrafica'
        );


    if (vistaGrafica) {
        vistaGrafica.style.display =
            'none';
    }


    if (vistaTabla) {
        vistaTabla.style.display =
            '';
    }


    renderizarCuentas();

}


// ============================================================
// TEXTO DE CUENTAS EN GRÁFICA
// ============================================================

function actualizarTextoCuentasGrafica() {

    const elemento =
        document.getElementById(
            'contabilidadCuentasGrafica'
        );


    if (!elemento) return;


    elemento.textContent =
        cuentasGraficaContabilidad.length === 1
            ? `Cuenta: ${cuentasGraficaContabilidad[0]}`
            : `${cuentasGraficaContabilidad.length} cuentas seleccionadas`;

}


// ============================================================
// ABRIR MODAL
// ============================================================

function abrirModalParametros() {

    const elemento =
        document.getElementById(
            'modalParametrosContabilidad'
        );


    if (
        !elemento ||
        !window.bootstrap
    ) {
        return;
    }


    const modal =
        bootstrap.Modal.getOrCreateInstance(
            elemento
        );


    modal.show();

}


// ============================================================
// CERRAR MODAL
// ============================================================

function cerrarModalParametros() {

    const elemento =
        document.getElementById(
            'modalParametrosContabilidad'
        );


    if (
        !elemento ||
        !window.bootstrap
    ) {
        return;
    }


    const modal =
        bootstrap.Modal.getInstance(
            elemento
        );


    if (modal) {

        if (
            document.activeElement
            instanceof HTMLElement
        ) {

            document.activeElement.blur();

        }


        modal.hide();

    }

}


// ============================================================
// ENTIDADES
// ============================================================

async function cargarEntidadesContabilidad() {

    try {

        const response =
            await fetch(
                `${API_BASE_URL}/entidades`,
                {
                    headers: {
                        'Authorization':
                            getToken(),

                        'Content-Type':
                            'application/json'
                    }
                }
            );


        if (!response.ok) {

            throw new Error(
                `Error al cargar entidades: ${response.status}`
            );

        }


        const resultado =
            await response.json();


        entidadesContabilidad =
            Array.isArray(
                resultado.entidades
            )
                ? resultado.entidades
                : [];


        renderizarEntidadesContabilidad();


    } catch (error) {

        console.error(
            'Error al cargar entidades:',
            error
        );

        entidadesContabilidad = [];

    }

}


// ============================================================
// RENDER ENTIDADES
// ============================================================

function renderizarEntidadesContabilidad() {

    const contenedor =
        document.getElementById(
            'cont-lista-entidades'
        );


    if (!contenedor) return;


    const htmlEntidades =
        entidadesContabilidad
            .map(entidad => `

                <div
                    class="
                        form-check
                        form-check-inline
                    "
                >

                    <input
                        class="
                            form-check-input
                            cont-entidad-selector
                        "
                        type="checkbox"
                        value="${escapeHtml(entidad)}"
                        id="cont-entidad-${escapeHtml(entidad)}"
                    >

                    <label
                        class="form-check-label"
                        for="cont-entidad-${escapeHtml(entidad)}"
                    >
                        ${escapeHtml(entidad)}
                    </label>

                </div>

            `)
            .join('');


    const htmlTodas = `

        <div
            class="
                form-check
                form-check-inline
            "
        >

            <input
                class="form-check-input"
                type="checkbox"
                id="cont-entidad-todas"
            >

            <label
                class="form-check-label"
                for="cont-entidad-todas"
            >
                Seleccionar todas
            </label>

        </div>

    `;


    contenedor.innerHTML =
        htmlEntidades +
        htmlTodas;


    const checkTodas =
        document.getElementById(
            'cont-entidad-todas'
        );


    const checks =
        Array.from(
            document.querySelectorAll(
                '.cont-entidad-selector'
            )
        );


    checkTodas
        ?.addEventListener(
            'change',
            () => {

                checks.forEach(
                    item => {

                        item.checked =
                            checkTodas.checked;

                    }
                );


                checkTodas.indeterminate =
                    false;

            }
        );


    checks.forEach(
        item => {

            item.addEventListener(
                'change',
                actualizarSeleccionTodasEntidades
            );

        }
    );

}


// ============================================================
// ESTADO SELECCIONAR TODAS ENTIDADES
// ============================================================

function actualizarSeleccionTodasEntidades() {

    const checkTodas =
        document.getElementById(
            'cont-entidad-todas'
        );


    if (!checkTodas) return;


    const checks =
        Array.from(
            document.querySelectorAll(
                '.cont-entidad-selector'
            )
        );


    const seleccionadas =
        checks.filter(
            item => item.checked
        );


    checkTodas.checked =
        checks.length > 0 &&
        seleccionadas.length ===
            checks.length;


    checkTodas.indeterminate =
        seleccionadas.length > 0 &&
        seleccionadas.length <
            checks.length;

}


// ============================================================
// AÑOS
// ============================================================

async function cargarAniosContabilidad() {

    try {

        const response =
            await fetch(
                `${API_BASE_URL}/anios`,
                {
                    headers: {
                        'Authorization':
                            getToken(),

                        'Content-Type':
                            'application/json'
                    }
                }
            );


        if (!response.ok) {

            throw new Error(
                `Error al cargar años: ${response.status}`
            );

        }


        const resultado =
            await response.json();


        aniosContabilidad =
            Array.isArray(
                resultado.anios
            )
                ? resultado.anios
                : [];


        configurarPeriodoInicial();


    } catch (error) {

        console.error(
            'Error al cargar años:',
            error
        );

        aniosContabilidad = [];

    }

}


// ============================================================
// PERIODO INICIAL
// ============================================================

function configurarPeriodoInicial() {

    if (
        aniosContabilidad.length === 0
    ) {
        return;
    }


    const minAnio =
        Math.min(
            ...aniosContabilidad
        );


    const maxAnio =
        Math.max(
            ...aniosContabilidad
        );


    const inicio =
        document.getElementById(
            'cont-fecha-inicio'
        );


    const fin =
        document.getElementById(
            'cont-fecha-fin'
        );


    if (
        inicio &&
        !inicio.value
    ) {

        inicio.value =
            `${minAnio}-01`;

    }


    if (
        fin &&
        !fin.value
    ) {

        fin.value =
            `${maxAnio}-12`;

    }

}


// ============================================================
// SUMAR REGISTROS
// ============================================================

function actualizarModoSumaDesdeUI() {

    const radio =
        document.querySelector(
            'input[name="cont-sumar-registros"]:checked'
        );


    sumarRegistrosContabilidad =
        radio?.value === 'si';


    actualizarEstadoControlesSuma();

}


// ============================================================
// HABILITAR / DESHABILITAR SUMA
// ============================================================

function actualizarDisponibilidadSuma() {

    const radioSi =
        document.getElementById(
            'cont-sumar-si'
        );


    if (!radioSi) return;


    const permitido =
        cuentasGraficaContabilidad.length >= 2;


    radioSi.disabled =
        !permitido;


    if (
        !permitido &&
        radioSi.checked
    ) {

        const radioNo =
            document.getElementById(
                'cont-sumar-no'
            );


        if (radioNo) {
            radioNo.checked = true;
        }


        sumarRegistrosContabilidad =
            false;

    }


    actualizarEstadoControlesSuma();

}


// ============================================================
// DESHABILITAR ENTIDADES / VISTA EN MODO SUMA
// ============================================================

function actualizarEstadoControlesSuma() {

    const bloque =
        document.getElementById(
            'cont-bloque-entidades'
        );


    const deshabilitar =
        sumarRegistrosContabilidad;


    document
        .querySelectorAll(
            `
                .cont-entidad-selector,
                #cont-entidad-todas,
                input[name="cont-vista-grafica"]
            `
        )
        .forEach(
            control => {

                control.disabled =
                    deshabilitar;

            }
        );


    if (bloque) {

        bloque.style.opacity =
            deshabilitar
                ? '0.45'
                : '1';

    }

}


// ============================================================
// GENERAR GRÁFICA
// ============================================================

async function generarGraficaContabilidad(
    {
        guardarPreferencia = true,
        restaurarSeries = []
    } = {}
) {

    try {

        const fechaInicio =
            document
                .getElementById(
                    'cont-fecha-inicio'
                )
                ?.value;


        const fechaFin =
            document
                .getElementById(
                    'cont-fecha-fin'
                )
                ?.value;


        const tiposSeleccionados =
            Array.from(
                document.querySelectorAll(
                    '.cont-metrica-selector:checked'
                )
            )
            .map(
                item =>
                    item.dataset.tipo
            );


        const radioVista =
            document.querySelector(
                'input[name="cont-vista-grafica"]:checked'
            );


        vistaGraficaContabilidad =
            radioVista?.value === 'total'
                ? 'total'
                : 'entidad';


        const radioSuma =
            document.querySelector(
                'input[name="cont-sumar-registros"]:checked'
            );


        sumarRegistrosContabilidad =
            radioSuma?.value === 'si';


        const entidadesSeleccionadas =
            Array.from(
                document.querySelectorAll(
                    '.cont-entidad-selector:checked'
                )
            )
            .map(
                item => item.value
            );


        if (
            !fechaInicio ||
            !fechaFin
        ) {

            mostrarToast(
                'Selecciona el periodo.',
                'warning'
            );

            return;

        }


        if (
            fechaInicio >
            fechaFin
        ) {

            mostrarToast(
                'La fecha de inicio no puede ser mayor a la fecha de fin.',
                'warning'
            );

            return;

        }


        if (
            tiposSeleccionados.length === 0
        ) {

            mostrarToast(
                'Selecciona Real, Promedio o ambos.',
                'warning'
            );

            return;

        }


        if (
            sumarRegistrosContabilidad &&
            cuentasGraficaContabilidad.length < 2
        ) {

            mostrarToast(
                'Para sumar registros debes tener al menos dos cuentas seleccionadas.',
                'warning'
            );

            return;

        }


        if (
            !sumarRegistrosContabilidad &&
            entidadesSeleccionadas.length === 0
        ) {

            mostrarToast(
                'Selecciona al menos una entidad.',
                'warning'
            );

            return;

        }


        const response =
            await fetch(
                `${API_BASE_URL}/datos`,
                {
                    method: 'POST',

                    headers: {
                        'Authorization':
                            getToken(),

                        'Content-Type':
                            'application/json'
                    },

                    body:
                        JSON.stringify({

                            codigos:
                                cuentasGraficaContabilidad,

                            entidades:
                                sumarRegistrosContabilidad
                                    ? []
                                    : entidadesSeleccionadas,

                            desde:
                                fechaInicio,

                            hasta:
                                fechaFin,

                            vista:
                                vistaGraficaContabilidad,

                            sumarRegistros:
                                sumarRegistrosContabilidad

                        })
                }
            );


        const resultado =
            await response.json();


        if (
            !response.ok ||
            !resultado.success
        ) {

            throw new Error(
                resultado.error ||
                `Error al consultar datos: ${response.status}`
            );

        }


        if (
            !Array.isArray(
                resultado.series
            ) ||
            resultado.series.length === 0
        ) {

            mostrarToast(
                'No hay datos para los parámetros seleccionados.',
                'warning'
            );

            return;

        }


        dibujarResultadoContabilidad(
            resultado,
            tiposSeleccionados,
            fechaInicio,
            fechaFin
        );


        if (
            Array.isArray(
                restaurarSeries
            ) &&
            restaurarSeries.length > 0
        ) {

            restaurarSeriesOcultas(
                restaurarSeries
            );

        }


        cerrarModalParametros();


        if (guardarPreferencia) {

            await guardarPreferenciaGraficaContabilidad();

        }


    } catch (error) {

        console.error(
            'Error al generar gráfica de Contabilidad:',
            error
        );


        mostrarToast(
            error.message ||
            'No fue posible generar la gráfica.',
            'warning'
        );

    }

}


// ============================================================
// PREPARAR / DIBUJAR RESULTADO
// ============================================================

function dibujarResultadoContabilidad(
    resultado,
    tiposSeleccionados,
    fechaInicio,
    fechaFin
) {

    const datosGrafica =
        prepararDatosParaGestorGrafica(
            resultado,
            tiposSeleccionados
        );


    const nombresSeries =
        [
            ...new Set(
                datosGrafica.map(
                    fila =>
                        fila.nombre_campo
                )
            )
        ];


    graficaContabilidad.datosGlobales =
        datosGrafica;


    const [anioI, mesI] =
        fechaInicio
            .split('-')
            .map(Number);


    const [anioF, mesF] =
        fechaFin
            .split('-')
            .map(Number);


    graficaContabilidad
        .dibujarGraficaPorRango(
            nombresSeries,

            new Date(
                anioI,
                mesI - 1,
                1
            ),

            new Date(
                anioF,
                mesF - 1,
                1
            )
        );

}


// ============================================================
// ADAPTAR RESPUESTA AL FORMATO DE GestorGrafica
// ============================================================

function prepararDatosParaGestorGrafica(
    resultado,
    tiposSeleccionados
) {

    const meses = [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre'
    ];


    const filas =
        new Map();


    resultado.series.forEach(
        serie => {

            tiposSeleccionados.forEach(
                tipo => {

                    const valores =
                        tipo === 'Real'
                            ? serie.real
                            : serie.promedio;


                    const nombreSerie =
                        resultado.sumarRegistros
                            ? (
                                tipo === 'Real'
                                    ? 'Suma Importe Real'
                                    : 'Suma Importe Promedio'
                            )
                            : `${serie.codigo} ${serie.entidad} IMPORTE ${tipo}`;


                    resultado.periodos.forEach(
                        (
                            periodo,
                            indice
                        ) => {

                            const [
                                anio,
                                mes
                            ] =
                                periodo
                                    .split('-')
                                    .map(Number);


                            const clave =
                                `${nombreSerie}|${anio}`;


                            if (
                                !filas.has(
                                    clave
                                )
                            ) {

                                filas.set(
                                    clave,
                                    {
                                        nombre_campo:
                                            nombreSerie,

                                        anio,

                                        tabla:
                                            'Contabilidad'
                                    }
                                );

                            }


                            filas
                                .get(clave)[
                                    meses[mes - 1]
                                ] =
                                    valores?.[indice] ??
                                    null;

                        }
                    );

                }
            );

        }
    );


    return Array.from(
        filas.values()
    );

}


// ============================================================
// GUARDAR ÚLTIMA GRÁFICA
// ============================================================

async function guardarPreferenciaGraficaContabilidad() {

    if (
        cuentasGraficaContabilidad.length === 0
    ) {
        return;
    }


    try {

        const fechaInicio =
            document
                .getElementById(
                    'cont-fecha-inicio'
                )
                ?.value || '';


        const fechaFin =
            document
                .getElementById(
                    'cont-fecha-fin'
                )
                ?.value || '';


        const entidades =
            Array.from(
                document.querySelectorAll(
                    '.cont-entidad-selector:checked'
                )
            )
            .map(
                item => item.value
            );


        const tipos =
            Array.from(
                document.querySelectorAll(
                    '.cont-metrica-selector:checked'
                )
            )
            .map(
                item => item.dataset.tipo
            );


        const radioVista =
            document.querySelector(
                'input[name="cont-vista-grafica"]:checked'
            );


        const radioSuma =
            document.querySelector(
                'input[name="cont-sumar-registros"]:checked'
            );


        const seriesOcultas =
            obtenerSeriesOcultas();


        const response =
            await fetch(
                `${URL_BASE_API}/api/preferencias/contabilidad/ultima_grafica`,
                {
                    method: 'PUT',

                    headers: {
                        'Authorization':
                            getToken(),

                        'Content-Type':
                            'application/json'
                    },

                    body:
                        JSON.stringify({

                            valor: {

                                codigos:
                                    cuentasGraficaContabilidad,

                                fechaInicio,

                                fechaFin,

                                entidades,

                                vistaGrafica:
                                    radioVista?.value === 'total'
                                        ? 'total'
                                        : 'entidad',

                                sumarRegistros:
                                    radioSuma?.value === 'si',

                                tipos,

                                seriesOcultas

                            }

                        })

                }
            );


        if (!response.ok) {

            throw new Error(
                `Error al guardar última gráfica: ${response.status}`
            );

        }


    } catch (error) {

        console.error(
            'Error al guardar preferencia de gráfica:',
            error
        );

    }

}


// ============================================================
// RESTAURAR ÚLTIMA GRÁFICA
// ============================================================

async function restaurarUltimaGraficaContabilidad() {

    try {

        const response =
            await fetch(
                `${URL_BASE_API}/api/preferencias/contabilidad/ultima_grafica`,
                {
                    method: 'GET',

                    headers: {
                        'Authorization':
                            getToken(),

                        'Content-Type':
                            'application/json'
                    }
                }
            );


        if (!response.ok) {

            throw new Error(
                `Error al consultar última gráfica: ${response.status}`
            );

        }


        const resultado =
            await response.json();


        if (
            !resultado.success ||
            !resultado.existe ||
            !resultado.valor
        ) {

            return;

        }


        const preferencia =
            resultado.valor;


        if (
            !Array.isArray(
                preferencia.codigos
            ) ||
            preferencia.codigos.length === 0
        ) {

            return;

        }


        ultimaPreferenciaGrafica =
            preferencia;


        await abrirGraficaContabilidad(
            preferencia.codigos,
            {
                abrirParametros:
                    false,

                restaurando:
                    true
            }
        );


        aplicarPreferenciaGraficaEnControles(
            preferencia
        );


        const tieneParametros =
            preferencia.fechaInicio &&
            preferencia.fechaFin &&
            Array.isArray(
                preferencia.tipos
            ) &&
            preferencia.tipos.length > 0 &&
            (
                preferencia.sumarRegistros === true ||
                (
                    Array.isArray(
                        preferencia.entidades
                    ) &&
                    preferencia.entidades.length > 0
                )
            );


        if (tieneParametros) {

            await generarGraficaContabilidad(
                {
                    guardarPreferencia:
                        false,

                    restaurarSeries:
                        preferencia.seriesOcultas || []
                }
            );

        }


    } catch (error) {

        console.error(
            'Error al restaurar última gráfica:',
            error
        );

    }

}


// ============================================================
// APLICAR PREFERENCIA EN CONTROLES
// ============================================================

function aplicarPreferenciaGraficaEnControles(
    preferencia
) {

    const inicio =
        document.getElementById(
            'cont-fecha-inicio'
        );


    const fin =
        document.getElementById(
            'cont-fecha-fin'
        );


    if (
        inicio &&
        preferencia.fechaInicio
    ) {

        inicio.value =
            preferencia.fechaInicio;

    }


    if (
        fin &&
        preferencia.fechaFin
    ) {

        fin.value =
            preferencia.fechaFin;

    }


    document
        .querySelectorAll(
            '.cont-entidad-selector'
        )
        .forEach(
            item => {

                item.checked =
                    preferencia.entidades
                        ?.includes(
                            item.value
                        ) || false;

            }
        );


    actualizarSeleccionTodasEntidades();


    vistaGraficaContabilidad =
        preferencia.vistaGrafica ===
            'total'
            ? 'total'
            : 'entidad';


    const radioVista =
        document.getElementById(
            vistaGraficaContabilidad ===
                'total'
                ? 'cont-vista-total'
                : 'cont-vista-entidad'
        );


    if (radioVista) {

        radioVista.checked =
            true;

    }


    sumarRegistrosContabilidad =
        preferencia.sumarRegistros ===
            true;


    const radioSuma =
        document.getElementById(
            sumarRegistrosContabilidad
                ? 'cont-sumar-si'
                : 'cont-sumar-no'
        );


    if (radioSuma) {

        radioSuma.checked =
            true;

    }


    document
        .querySelectorAll(
            '.cont-metrica-selector'
        )
        .forEach(
            item => {

                item.checked =
                    preferencia.tipos
                        ?.includes(
                            item.dataset.tipo
                        ) || false;

            }
        );


    actualizarDisponibilidadSuma();

    actualizarEstadoControlesSuma();

}


// ============================================================
// SERIES OCULTAS
// ============================================================

function obtenerSeriesOcultas() {

    const ocultas = [];


    if (
        !graficaContabilidad
            ?.GraficaInstance
    ) {

        return ocultas;

    }


    graficaContabilidad
        .GraficaInstance
        .data
        .datasets
        .forEach(
            (
                dataset,
                index
            ) => {

                if (
                    !graficaContabilidad
                        .GraficaInstance
                        .isDatasetVisible(
                            index
                        )
                ) {

                    ocultas.push(
                        dataset.label
                    );

                }

            }
        );


    return ocultas;

}


function restaurarSeriesOcultas(
    seriesOcultas
) {

    if (
        !graficaContabilidad
            ?.GraficaInstance
    ) {
        return;
    }


    graficaContabilidad
        .GraficaInstance
        .data
        .datasets
        .forEach(
            (
                dataset,
                index
            ) => {

                if (
                    seriesOcultas.includes(
                        dataset.label
                    )
                ) {

                    graficaContabilidad
                        .GraficaInstance
                        .setDatasetVisibility(
                            index,
                            false
                        );

                }

            }
        );


    graficaContabilidad
        .GraficaInstance
        .update();

}


// ============================================================
// LIMPIAR PARÁMETROS
// ============================================================

function limpiarParametrosGrafica() {

    const inicio =
        document.getElementById(
            'cont-fecha-inicio'
        );


    const fin =
        document.getElementById(
            'cont-fecha-fin'
        );


    if (inicio) {
        inicio.value = '';
    }


    if (fin) {
        fin.value = '';
    }


    document
        .querySelectorAll(
            '.cont-entidad-selector'
        )
        .forEach(
            item => {

                item.checked =
                    false;

            }
        );


    const todas =
        document.getElementById(
            'cont-entidad-todas'
        );


    if (todas) {

        todas.checked = false;

        todas.indeterminate = false;

    }


    const vistaEntidad =
        document.getElementById(
            'cont-vista-entidad'
        );


    if (vistaEntidad) {

        vistaEntidad.checked =
            true;

    }


    vistaGraficaContabilidad =
        'entidad';


    const sumaNo =
        document.getElementById(
            'cont-sumar-no'
        );


    if (sumaNo) {

        sumaNo.checked =
            true;

    }


    sumarRegistrosContabilidad =
        false;


    document
        .querySelectorAll(
            '.cont-metrica-selector'
        )
        .forEach(
            item => {

                item.checked =
                    false;

            }
        );


    actualizarEstadoControlesSuma();

}


// ============================================================
// EVENTOS
// ============================================================

function bindEventsContabilidad() {

    // --------------------------------------------------------
    // EVENTOS DEL MENÚ "..."
    // --------------------------------------------------------

    document.removeEventListener(
        'contabilidad:seleccionar',
        alternarModoSeleccion
    );


    document.addEventListener(
        'contabilidad:seleccionar',
        alternarModoSeleccion
    );


    document.removeEventListener(
        'contabilidad:mostrar',
        alternarPanelMostrar
    );


    document.addEventListener(
        'contabilidad:mostrar',
        alternarPanelMostrar
    );


    // --------------------------------------------------------
    // FILTROS
    // --------------------------------------------------------

    const filtroCuenta =
        document.getElementById(
            'filtroCuenta'
        );


    const filtroDescripcion =
        document.getElementById(
            'filtroDescripcion'
        );


    filtroCuenta
        ?.addEventListener(
            'input',
            () =>
                aplicarFiltros(true)
        );


    filtroDescripcion
        ?.addEventListener(
            'input',
            () =>
                aplicarFiltros(true)
        );


    // --------------------------------------------------------
    // TABLA
    // --------------------------------------------------------

    document
        .getElementById(
            'tablaContabilidadBody'
        )
        ?.addEventListener(
            'click',
            async event => {

                const checkbox =
                    event.target.closest(
                        '.contabilidad-check-cuenta'
                    );


                if (checkbox) {

                    const codigo =
                        checkbox.dataset.codigo;


                    if (
                        checkbox.checked
                    ) {

                        cuentasSeleccionadas.add(
                            codigo
                        );

                    } else {

                        cuentasSeleccionadas.delete(
                            codigo
                        );

                    }


                    actualizarEstadoSeleccion();

                    return;

                }


                const boton =
                    event.target.closest(
                        '.contabilidad-cuenta-link'
                    );


                if (!boton) return;


                await abrirCuentaContabilidad(
                    boton.dataset.codigo
                );

            }
        );


    // --------------------------------------------------------
    // TODOS
    // --------------------------------------------------------

    document
        .getElementById(
            'contabilidadSeleccionarTodos'
        )
        ?.addEventListener(
            'change',
            seleccionarTodasVisibles
        );


    // --------------------------------------------------------
    // GRAFICAR SELECCIÓN
    // --------------------------------------------------------

    document
        .getElementById(
            'btnGraficarContabilidad'
        )
        ?.addEventListener(
            'click',
            async () => {

                await abrirGraficaContabilidad(
                    Array.from(
                        cuentasSeleccionadas
                    )
                );

            }
        );


    // --------------------------------------------------------
    // MOSTRAR COLUMNAS
    // --------------------------------------------------------

    document
        .getElementById(
            'mostrarColumnaCuenta'
        )
        ?.addEventListener(
            'change',
            async event => {

                if (
                    !event.target.checked &&
                    !columnasVisibles.descripcion
                ) {

                    event.target.checked =
                        true;

                    return;

                }


                columnasVisibles.cuenta =
                    event.target.checked;


                aplicarVisibilidadColumnas();

                await guardarPreferenciasColumnas();

            }
        );


    document
        .getElementById(
            'mostrarColumnaDescripcion'
        )
        ?.addEventListener(
            'change',
            async event => {

                if (
                    !event.target.checked &&
                    !columnasVisibles.cuenta
                ) {

                    event.target.checked =
                        true;

                    return;

                }


                columnasVisibles.descripcion =
                    event.target.checked;


                aplicarVisibilidadColumnas();

                await guardarPreferenciasColumnas();

            }
        );


    document
        .getElementById(
            'btnMostrarTodasColumnas'
        )
        ?.addEventListener(
            'click',
            async () => {

                columnasVisibles.cuenta =
                    true;

                columnasVisibles.descripcion =
                    true;


                actualizarControlesColumnas();

                aplicarVisibilidadColumnas();

                await guardarPreferenciasColumnas();

            }
        );


    // --------------------------------------------------------
    // CERRAR PANEL MOSTRAR FUERA
    // --------------------------------------------------------

    document.removeEventListener(
        'click',
        cerrarPanelMostrarAlClickExterior
    );


    document.addEventListener(
        'click',
        cerrarPanelMostrarAlClickExterior
    );


    // --------------------------------------------------------
    // FILTROS EXPANDIR / LIMPIAR
    // --------------------------------------------------------

    document
        .getElementById(
            'btnToggleFiltrosContabilidad'
        )
        ?.addEventListener(
            'click',
            alternarFiltrosContabilidad
        );


    document
        .getElementById(
            'btnLimpiarFiltrosContabilidad'
        )
        ?.addEventListener(
            'click',
            limpiarFiltrosContabilidad
        );


    // --------------------------------------------------------
    // VOLVER
    // --------------------------------------------------------

    document
        .getElementById(
            'btnVolverContabilidad'
        )
        ?.addEventListener(
            'click',
            volverTablaContabilidad
        );


    // --------------------------------------------------------
    // SUMAR REGISTROS
    // --------------------------------------------------------

    document
        .querySelectorAll(
            'input[name="cont-sumar-registros"]'
        )
        .forEach(
            item => {

                item.addEventListener(
                    'change',
                    actualizarModoSumaDesdeUI
                );

            }
        );


    // --------------------------------------------------------
    // GRAFICAR DESDE MODAL
    // --------------------------------------------------------

    document
        .getElementById(
            'btnGenerarGraficaContabilidad'
        )
        ?.addEventListener(
            'click',
            async () => {

                await generarGraficaContabilidad();

            }
        );


    // --------------------------------------------------------
    // LIMPIAR PARÁMETROS
    // --------------------------------------------------------

    document
        .getElementById(
            'btnLimpiarParametrosContabilidad'
        )
        ?.addEventListener(
            'click',
            limpiarParametrosGrafica
        );

}


// ============================================================
// MODO SELECCIÓN
// ============================================================

function alternarModoSeleccion() {

    modoSeleccion =
        !modoSeleccion;


    const toolbar =
        document.getElementById(
            'contabilidadSeleccionToolbar'
        );


    const header =
        document.getElementById(
            'contabilidadSeleccionHeader'
        );


    const filtro =
        document.getElementById(
            'contabilidadSeleccionFiltro'
        );


    if (
        !toolbar ||
        !header ||
        !filtro
    ) {
        return;
    }


    if (modoSeleccion) {

        toolbar.style.display =
            'flex';

        header.style.display =
            '';

        if (
            filtrosExpandidos
        ) {
            filtro.style.display =
                '';
        }

    } else {

        toolbar.style.display =
            'none';

        header.style.display =
            'none';

        filtro.style.display =
            'none';

        cuentasSeleccionadas.clear();

    }


    renderizarCuentas();

}


// ============================================================
// ESTADO SELECCIÓN
// ============================================================

function actualizarEstadoSeleccion() {

    const checkTodos =
        document.getElementById(
            'contabilidadSeleccionarTodos'
        );


    const btnGraficar =
        document.getElementById(
            'btnGraficarContabilidad'
        );


    if (
        !checkTodos ||
        !btnGraficar
    ) {
        return;
    }


    const codigosVisibles =
        cuentasFiltradas.map(
            cuenta =>
                String(
                    cuenta.codigo
                )
        );


    const seleccionadasVisibles =
        codigosVisibles.filter(
            codigo =>
                cuentasSeleccionadas.has(
                    codigo
                )
        );


    checkTodos.checked =
        codigosVisibles.length > 0 &&
        seleccionadasVisibles.length ===
            codigosVisibles.length;


    checkTodos.indeterminate =
        seleccionadasVisibles.length > 0 &&
        seleccionadasVisibles.length <
            codigosVisibles.length;


    btnGraficar.disabled =
        cuentasSeleccionadas.size === 0;

}


// ============================================================
// TODOS VISIBLES
// ============================================================

function seleccionarTodasVisibles() {

    const checkTodos =
        document.getElementById(
            'contabilidadSeleccionarTodos'
        );


    if (!checkTodos) return;


    cuentasFiltradas.forEach(
        cuenta => {

            const codigo =
                String(
                    cuenta.codigo
                );


            if (
                checkTodos.checked
            ) {

                cuentasSeleccionadas.add(
                    codigo
                );

            } else {

                cuentasSeleccionadas.delete(
                    codigo
                );

            }

        }
    );


    renderizarCuentas();

}


// ============================================================
// PANEL MOSTRAR
// ============================================================

function alternarPanelMostrar() {

    const panel =
        document.getElementById(
            'contabilidadPanelMostrar'
        );


    if (!panel) return;


    const abierto =
        panel.style.display !==
            'none';


    panel.style.display =
        abierto
            ? 'none'
            : 'block';


    actualizarControlesColumnas();

}


// ============================================================
// CONTROLES COLUMNAS
// ============================================================

function actualizarControlesColumnas() {

    const cuenta =
        document.getElementById(
            'mostrarColumnaCuenta'
        );


    const descripcion =
        document.getElementById(
            'mostrarColumnaDescripcion'
        );


    if (cuenta) {

        cuenta.checked =
            columnasVisibles.cuenta;

    }


    if (descripcion) {

        descripcion.checked =
            columnasVisibles.descripcion;

    }

}


function aplicarVisibilidadColumnas() {

    document
        .querySelectorAll(
            '.contabilidad-col-cuenta'
        )
        .forEach(
            elemento => {

                elemento.style.display =
                    columnasVisibles.cuenta
                        ? ''
                        : 'none';

            }
        );


    document
        .querySelectorAll(
            '.contabilidad-col-descripcion'
        )
        .forEach(
            elemento => {

                elemento.style.display =
                    columnasVisibles.descripcion
                        ? ''
                        : 'none';

            }
        );

}


// ============================================================
// CERRAR MOSTRAR FUERA
// ============================================================

function cerrarPanelMostrarAlClickExterior(
    event
) {

    const panel =
        document.getElementById(
            'contabilidadPanelMostrar'
        );


    if (
        !panel ||
        panel.style.display ===
            'none'
    ) {
        return;
    }


    if (
        panel.contains(
            event.target
        )
    ) {
        return;
    }


    if (
        event.target.closest(
            '#btn-header-mostrar'
        )
    ) {
        return;
    }


    panel.style.display =
        'none';

}


// ============================================================
// PREFERENCIAS COLUMNAS
// ============================================================

async function cargarPreferenciasColumnas() {

    try {

        const response =
            await fetch(
                `${URL_BASE_API}/api/preferencias/contabilidad/columnas`,
                {
                    headers: {
                        'Authorization':
                            getToken(),

                        'Content-Type':
                            'application/json'
                    }
                }
            );


        if (!response.ok) {
            throw new Error(
                `Error al cargar preferencias: ${response.status}`
            );
        }


        const resultado =
            await response.json();


        if (
            resultado.success &&
            resultado.existe &&
            resultado.valor
        ) {

            columnasVisibles = {
                cuenta:
                    resultado.valor.cuenta !==
                        false,

                descripcion:
                    resultado.valor.descripcion !==
                        false
            };

        }


        if (
            !columnasVisibles.cuenta &&
            !columnasVisibles.descripcion
        ) {

            columnasVisibles = {
                cuenta: true,
                descripcion: true
            };

        }


    } catch (error) {

        console.error(
            'Error al cargar preferencias de columnas:',
            error
        );

    }

}


async function guardarPreferenciasColumnas() {

    try {

        const response =
            await fetch(
                `${URL_BASE_API}/api/preferencias/contabilidad/columnas`,
                {
                    method: 'PUT',

                    headers: {
                        'Authorization':
                            getToken(),

                        'Content-Type':
                            'application/json'
                    },

                    body:
                        JSON.stringify({
                            valor:
                                columnasVisibles
                        })
                }
            );


        if (!response.ok) {
            throw new Error(
                `Error al guardar preferencias: ${response.status}`
            );
        }


    } catch (error) {

        console.error(
            'Error al guardar preferencias de columnas:',
            error
        );

    }

}


// ============================================================
// PREFERENCIAS FILTROS
// ============================================================

async function cargarPreferenciasFiltros() {

    try {

        const response =
            await fetch(
                `${URL_BASE_API}/api/preferencias/contabilidad/filtros`,
                {
                    headers: {
                        'Authorization':
                            getToken(),

                        'Content-Type':
                            'application/json'
                    }
                }
            );


        if (!response.ok) {
            throw new Error(
                `Error al cargar filtros: ${response.status}`
            );
        }


        const resultado =
            await response.json();


        if (
            resultado.success &&
            resultado.existe &&
            resultado.valor
        ) {

            filtrosContabilidad = {
                cuenta:
                    String(
                        resultado.valor.cuenta ||
                        ''
                    ),

                descripcion:
                    String(
                        resultado.valor.descripcion ||
                        ''
                    )
            };

        }


    } catch (error) {

        console.error(
            'Error al cargar filtros de Contabilidad:',
            error
        );

    }

}


async function guardarPreferenciasFiltros() {

    try {

        const response =
            await fetch(
                `${URL_BASE_API}/api/preferencias/contabilidad/filtros`,
                {
                    method: 'PUT',

                    headers: {
                        'Authorization':
                            getToken(),

                        'Content-Type':
                            'application/json'
                    },

                    body:
                        JSON.stringify({

                            valor: {
                                cuenta:
                                    filtrosContabilidad.cuenta,

                                descripcion:
                                    filtrosContabilidad.descripcion
                            }

                        })
                }
            );


        if (!response.ok) {
            throw new Error(
                `Error al guardar filtros: ${response.status}`
            );
        }


    } catch (error) {

        console.error(
            'Error al guardar filtros de Contabilidad:',
            error
        );

    }

}


// ============================================================
// DEBOUNCE FILTROS
// ============================================================

function programarGuardadoFiltros() {

    clearTimeout(
        timerGuardarFiltros
    );


    timerGuardarFiltros =
        setTimeout(
            guardarPreferenciasFiltros,
            400
        );

}


// ============================================================
// RESTAURAR INPUTS FILTRO
// ============================================================

function restaurarFiltrosEnInputs() {

    const cuenta =
        document.getElementById(
            'filtroCuenta'
        );


    const descripcion =
        document.getElementById(
            'filtroDescripcion'
        );


    if (cuenta) {

        cuenta.value =
            filtrosContabilidad.cuenta;

    }


    if (descripcion) {

        descripcion.value =
            filtrosContabilidad.descripcion;

    }

}


// ============================================================
// EXPANDIR / CONTRAER FILTROS
// ============================================================

function alternarFiltrosContabilidad() {

    filtrosExpandidos =
        !filtrosExpandidos;


    const fila =
        document.getElementById(
            'filaFiltrosContabilidad'
        );


    const icono =
        document.getElementById(
            'iconToggleFiltrosContabilidad'
        );


    const boton =
        document.getElementById(
            'btnToggleFiltrosContabilidad'
        );


    const seleccionFiltro =
        document.getElementById(
            'contabilidadSeleccionFiltro'
        );


    if (
        !fila ||
        !icono
    ) {
        return;
    }


    fila.style.display =
        filtrosExpandidos
            ? ''
            : 'none';


    if (seleccionFiltro) {

        seleccionFiltro.style.display =
            (
                filtrosExpandidos &&
                modoSeleccion
            )
                ? ''
                : 'none';

    }


    icono.classList.toggle(
        'fa-chevron-down',
        !filtrosExpandidos
    );


    icono.classList.toggle(
        'fa-chevron-up',
        filtrosExpandidos
    );


    if (boton) {

        boton.title =
            filtrosExpandidos
                ? 'Ocultar filtros'
                : 'Mostrar filtros';

    }

}


// ============================================================
// LIMPIAR FILTROS
// ============================================================

async function limpiarFiltrosContabilidad() {

    const cuenta =
        document.getElementById(
            'filtroCuenta'
        );


    const descripcion =
        document.getElementById(
            'filtroDescripcion'
        );


    if (cuenta) {
        cuenta.value = '';
    }


    if (descripcion) {
        descripcion.value = '';
    }


    filtrosContabilidad = {
        cuenta: '',
        descripcion: ''
    };


    aplicarFiltros(false);

    await guardarPreferenciasFiltros();

}


// ============================================================
// ESCAPAR HTML
// ============================================================

function escapeHtml(valor) {

    return String(
        valor ?? ''
    )
        .replaceAll(
            '&',
            '&amp;'
        )
        .replaceAll(
            '<',
            '&lt;'
        )
        .replaceAll(
            '>',
            '&gt;'
        )
        .replaceAll(
            '"',
            '&quot;'
        )
        .replaceAll(
            "'",
            '&#039;'
        );

}

